import { render, staticRenderFns } from "./ServicoCadastroModal.vue?vue&type=template&id=343d47eb&scoped=true"
import script from "./ServicoCadastroModal.vue?vue&type=script&lang=js"
export * from "./ServicoCadastroModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343d47eb",
  null
  
)

export default component.exports